import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/audit.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm audit [fix|signatures]
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/audit.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <h3>{`Description`}</h3>
    <p>{`The audit command submits a description of the dependencies configured in
your project to your default registry and asks for a report of known
vulnerabilities.  If any vulnerabilities are found, then the impact and
appropriate remediation will be calculated.  If the `}<inlineCode parentName="p">{`fix`}</inlineCode>{` argument is
provided, then remediations will be applied to the package tree.`}</p>
    <p>{`The command will exit with a 0 exit code if no vulnerabilities were found.`}</p>
    <p>{`Note that some vulnerabilities cannot be fixed automatically and will
require manual intervention or review.  Also note that since `}<inlineCode parentName="p">{`npm audit
fix`}</inlineCode>{` runs a full-fledged `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` under the hood, all configs that
apply to the installer will also apply to `}<inlineCode parentName="p">{`npm install`}</inlineCode>{` -- so things like
`}<inlineCode parentName="p">{`npm audit fix --package-lock-only`}</inlineCode>{` will work as expected.`}</p>
    <p>{`By default, the audit command will exit with a non-zero code if any
vulnerability is found. It may be useful in CI environments to include the
`}<inlineCode parentName="p">{`--audit-level`}</inlineCode>{` parameter to specify the minimum vulnerability level that
will cause the command to fail. This option does not filter the report
output, it simply changes the command's failure threshold.`}</p>
    <h3>{`Audit Signatures`}</h3>
    <p>{`To ensure the integrity of packages you download from the public npm registry, or any registry that supports signatures, you can verify the registry signatures of downloaded packages using the npm CLI.`}</p>
    <p>{`Registry signatures can be verified using the following `}<inlineCode parentName="p">{`audit`}</inlineCode>{` command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm audit signatures
`}</code></pre>
    <p>{`The npm CLI supports registry signatures and signing keys provided by any registry if the following conventions are followed:`}</p>
    <ol>
      <li parentName="ol">{`Signatures are provided in the package's `}<inlineCode parentName="li">{`packument`}</inlineCode>{` in each published version within the `}<inlineCode parentName="li">{`dist`}</inlineCode>{` object:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`"dist":{
  "..omitted..": "..omitted..",
  "signatures": [{
    "keyid": "SHA256:{{SHA256_PUBLIC_KEY}}",
    "sig": "a312b9c3cb4a1b693e8ebac5ee1ca9cc01f2661c14391917dcb111517f72370809..."
  }]
}
`}</code></pre>
    <p>{`See this `}<a parentName="p" {...{
        "href": "https://registry.npmjs.org/light-cycle/1.4.3"
      }}>{`example`}</a>{` of a signed package from the public npm registry.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`sig`}</inlineCode>{` is generated using the following template: `}<inlineCode parentName="p">{`\${package.name}@\${package.version}:\${package.dist.integrity}`}</inlineCode>{` and the `}<inlineCode parentName="p">{`keyid`}</inlineCode>{` has to match one of the public signing keys below.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Public signing keys are provided at `}<inlineCode parentName="li">{`registry-host.tld/-/npm/v1/keys`}</inlineCode>{` in the following format:`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`{
  "keys": [{
    "expires": null,
    "keyid": "SHA256:{{SHA256_PUBLIC_KEY}}",
    "keytype": "ecdsa-sha2-nistp256",
    "scheme": "ecdsa-sha2-nistp256",
    "key": "{{B64_PUBLIC_KEY}}"
  }]
}
`}</code></pre>
    <p>{`Keys response:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`expires`}</inlineCode>{`: null or a simplified extended `}<a href="https://en.wikipedia.org/wiki/ISO_8601" target="_blank">{`ISO 8601 format`}</a>{`: `}<inlineCode parentName="li">{`YYYY-MM-DDTHH:mm:ss.sssZ`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`keydid`}</inlineCode>{`: sha256 fingerprint of the public key`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`keytype`}</inlineCode>{`: only `}<inlineCode parentName="li">{`ecdsa-sha2-nistp256`}</inlineCode>{` is currently supported by the npm CLI`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`scheme`}</inlineCode>{`: only `}<inlineCode parentName="li">{`ecdsa-sha2-nistp256`}</inlineCode>{` is currently supported by the npm CLI`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`key`}</inlineCode>{`: base64 encoded public key`}</li>
    </ul>
    <p>{`See this `}<a href="https://registry.npmjs.org/-/npm/v1/keys" target="_blank">{`example key's response from the public npm registry`}</a>{`.`}</p>
    <h3>{`Audit Endpoints`}</h3>
    <p>{`There are two audit endpoints that npm may use to fetch vulnerability
information: the `}<inlineCode parentName="p">{`Bulk Advisory`}</inlineCode>{` endpoint and the `}<inlineCode parentName="p">{`Quick Audit`}</inlineCode>{` endpoint.`}</p>
    <h4>{`Bulk Advisory Endpoint`}</h4>
    <p>{`As of version 7, npm uses the much faster `}<inlineCode parentName="p">{`Bulk Advisory`}</inlineCode>{` endpoint to
optimize the speed of calculating audit results.`}</p>
    <p>{`npm will generate a JSON payload with the name and list of versions of each
package in the tree, and POST it to the default configured registry at
the path `}<inlineCode parentName="p">{`/-/npm/v1/security/advisories/bulk`}</inlineCode>{`.`}</p>
    <p>{`Any packages in the tree that do not have a `}<inlineCode parentName="p">{`version`}</inlineCode>{` field in their
package.json file will be ignored.  If any `}<inlineCode parentName="p">{`--omit`}</inlineCode>{` options are specified
(either via the `}<inlineCode parentName="p">{`--omit`}</inlineCode>{` config, or one of the shorthands such as
`}<inlineCode parentName="p">{`--production`}</inlineCode>{`, `}<inlineCode parentName="p">{`--only=dev`}</inlineCode>{`, and so on), then packages will be omitted
from the submitted payload as appropriate.`}</p>
    <p>{`If the registry responds with an error, or with an invalid response, then
npm will attempt to load advisory data from the `}<inlineCode parentName="p">{`Quick Audit`}</inlineCode>{` endpoint.`}</p>
    <p>{`The expected result will contain a set of advisory objects for each
dependency that matches the advisory range.  Each advisory object contains
a `}<inlineCode parentName="p">{`name`}</inlineCode>{`, `}<inlineCode parentName="p">{`url`}</inlineCode>{`, `}<inlineCode parentName="p">{`id`}</inlineCode>{`, `}<inlineCode parentName="p">{`severity`}</inlineCode>{`, `}<inlineCode parentName="p">{`vulnerable_versions`}</inlineCode>{`, and `}<inlineCode parentName="p">{`title`}</inlineCode>{`.`}</p>
    <p>{`npm then uses these advisory objects to calculate vulnerabilities and
meta-vulnerabilities of the dependencies within the tree.`}</p>
    <h4>{`Quick Audit Endpoint`}</h4>
    <p>{`If the `}<inlineCode parentName="p">{`Bulk Advisory`}</inlineCode>{` endpoint returns an error, or invalid data, npm will
attempt to load advisory data from the `}<inlineCode parentName="p">{`Quick Audit`}</inlineCode>{` endpoint, which is
considerably slower in most cases.`}</p>
    <p>{`The full package tree as found in `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` is submitted, along
with the following pieces of additional metadata:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`npm_version`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`node_version`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`platform`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`arch`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`node_env`}</inlineCode></li>
    </ul>
    <p>{`All packages in the tree are submitted to the Quick Audit endpoint.
Omitted dependency types are skipped when generating the report.`}</p>
    <h4>{`Scrubbing`}</h4>
    <p>{`Out of an abundance of caution, npm versions 5 and 6 would "scrub" any
packages from the submitted report if their name contained a `}<inlineCode parentName="p">{`/`}</inlineCode>{` character,
so as to avoid leaking the names of potentially private packages or git
URLs.`}</p>
    <p>{`However, in practice, this resulted in audits often failing to properly
detect meta-vulnerabilities, because the tree would appear to be invalid
due to missing dependencies, and prevented the detection of vulnerabilities
in package trees that used git dependencies or private modules.`}</p>
    <p>{`This scrubbing has been removed from npm as of version 7.`}</p>
    <h4>{`Calculating Meta-Vulnerabilities and Remediations`}</h4>
    <p>{`npm uses the
`}<a parentName="p" {...{
        "href": "http://npm.im/@npmcli/metavuln-calculator"
      }}><inlineCode parentName="a">{`@npmcli/metavuln-calculator`}</inlineCode></a>{`
module to turn a set of security advisories into a set of "vulnerability"
objects.  A "meta-vulnerability" is a dependency that is vulnerable by
virtue of dependence on vulnerable versions of a vulnerable package.`}</p>
    <p>{`For example, if the package `}<inlineCode parentName="p">{`foo`}</inlineCode>{` is vulnerable in the range `}<inlineCode parentName="p">{`>=1.0.2
<2.0.0`}</inlineCode>{`, and the package `}<inlineCode parentName="p">{`bar`}</inlineCode>{` depends on `}<inlineCode parentName="p">{`foo@^1.1.0`}</inlineCode>{`, then that version
of `}<inlineCode parentName="p">{`bar`}</inlineCode>{` can only be installed by installing a vulnerable version of `}<inlineCode parentName="p">{`foo`}</inlineCode>{`.
In this case, `}<inlineCode parentName="p">{`bar`}</inlineCode>{` is a "metavulnerability".`}</p>
    <p>{`Once metavulnerabilities for a given package are calculated, they are
cached in the `}<inlineCode parentName="p">{`~/.npm`}</inlineCode>{` folder and only re-evaluated if the advisory range
changes, or a new version of the package is published (in which case, the
new version is checked for metavulnerable status as well).`}</p>
    <p>{`If the chain of metavulnerabilities extends all the way to the root
project, and it cannot be updated without changing its dependency ranges,
then `}<inlineCode parentName="p">{`npm audit fix`}</inlineCode>{` will require the `}<inlineCode parentName="p">{`--force`}</inlineCode>{` option to apply the
remediation.  If remediations do not require changes to the dependency
ranges, then all vulnerable packages will be updated to a version that does
not have an advisory or metavulnerability posted against it.`}</p>
    <h3>{`Exit Code`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`npm audit`}</inlineCode>{` command will exit with a 0 exit code if no vulnerabilities
were found.  The `}<inlineCode parentName="p">{`npm audit fix`}</inlineCode>{` command will exit with 0 exit code if no
vulnerabilities are found `}<em parentName="p">{`or`}</em>{` if the remediation is able to successfully
fix all vulnerabilities.`}</p>
    <p>{`If vulnerabilities were found the exit code will depend on the
`}<inlineCode parentName="p">{`audit-level`}</inlineCode>{` configuration setting.`}</p>
    <h3>{`Examples`}</h3>
    <p>{`Scan your project for vulnerabilities and automatically install any compatible
updates to vulnerable dependencies:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm audit fix
`}</code></pre>
    <p>{`Run `}<inlineCode parentName="p">{`audit fix`}</inlineCode>{` without modifying `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{`, but still updating the
pkglock:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm audit fix --package-lock-only
`}</code></pre>
    <p>{`Skip updating `}<inlineCode parentName="p">{`devDependencies`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm audit fix --only=prod
`}</code></pre>
    <p>{`Have `}<inlineCode parentName="p">{`audit fix`}</inlineCode>{` install SemVer-major updates to toplevel dependencies, not
just SemVer-compatible ones:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm audit fix --force
`}</code></pre>
    <p>{`Do a dry run to get an idea of what `}<inlineCode parentName="p">{`audit fix`}</inlineCode>{` will do, and `}<em parentName="p">{`also`}</em>{` output
install information in JSON format:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm audit fix --dry-run --json
`}</code></pre>
    <p>{`Scan your project for vulnerabilities and just show the details, without
fixing anything:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm audit
`}</code></pre>
    <p>{`Get the detailed audit report in JSON format:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm audit --json
`}</code></pre>
    <p>{`Fail an audit only if the results include a vulnerability with a level of moderate or higher:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm audit --audit-level=moderate
`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`audit-level`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null, "info", "low", "moderate", "high", "critical", or "none"`}</li>
    </ul>
    <p>{`The minimum level of vulnerability for `}<inlineCode parentName="p">{`npm audit`}</inlineCode>{` to exit with a non-zero
exit code.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`dry-run`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Indicates that you don't want npm to make any changes and that it should
only report what it would have done. This can be passed into any of the
commands that modify your local installation, eg, `}<inlineCode parentName="p">{`install`}</inlineCode>{`, `}<inlineCode parentName="p">{`update`}</inlineCode>{`,
`}<inlineCode parentName="p">{`dedupe`}</inlineCode>{`, `}<inlineCode parentName="p">{`uninstall`}</inlineCode>{`, as well as `}<inlineCode parentName="p">{`pack`}</inlineCode>{` and `}<inlineCode parentName="p">{`publish`}</inlineCode>{`.`}</p>
    <p>{`Note: This is NOT honored by other network related commands, eg `}<inlineCode parentName="p">{`dist-tags`}</inlineCode>{`,
`}<inlineCode parentName="p">{`owner`}</inlineCode>{`, etc.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`force`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Removes various protections against unfortunate side effects, common
mistakes, unnecessary performance degradation, and malicious input.`}</p>
    <ul>
      <li parentName="ul">{`Allow clobbering non-npm files in global installs.`}</li>
      <li parentName="ul">{`Allow the `}<inlineCode parentName="li">{`npm version`}</inlineCode>{` command to work on an unclean git repository.`}</li>
      <li parentName="ul">{`Allow deleting the cache folder with `}<inlineCode parentName="li">{`npm cache clean`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Allow installing packages that have an `}<inlineCode parentName="li">{`engines`}</inlineCode>{` declaration requiring a
different version of npm.`}</li>
      <li parentName="ul">{`Allow installing packages that have an `}<inlineCode parentName="li">{`engines`}</inlineCode>{` declaration requiring a
different version of `}<inlineCode parentName="li">{`node`}</inlineCode>{`, even if `}<inlineCode parentName="li">{`--engine-strict`}</inlineCode>{` is enabled.`}</li>
      <li parentName="ul">{`Allow `}<inlineCode parentName="li">{`npm audit fix`}</inlineCode>{` to install modules outside your stated dependency
range (including SemVer-major changes).`}</li>
      <li parentName="ul">{`Allow unpublishing all versions of a published package.`}</li>
      <li parentName="ul">{`Allow conflicting peerDependencies to be installed in the root project.`}</li>
      <li parentName="ul">{`Implicitly set `}<inlineCode parentName="li">{`--yes`}</inlineCode>{` during `}<inlineCode parentName="li">{`npm init`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`Allow clobbering existing values in `}<inlineCode parentName="li">{`npm pkg`}</inlineCode></li>
      <li parentName="ul">{`Allow unpublishing of entire packages (not just a single version).`}</li>
    </ul>
    <p>{`If you don't have a clear idea of what you want to do, it is strongly
recommended that you do not use this option!`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`json`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Whether or not to output JSON data, rather than the normal output.`}</p>
    <ul>
      <li parentName="ul">{`In `}<inlineCode parentName="li">{`npm pkg set`}</inlineCode>{` it enables parsing set values with JSON.parse() before
saving them to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`.`}</li>
    </ul>
    <p>{`Not supported by all npm commands.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`package-lock-only`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If set to true, the current operation will only use the `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{`,
ignoring `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{`.`}</p>
    <p>{`For `}<inlineCode parentName="p">{`update`}</inlineCode>{` this means only the `}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` will be updated,
instead of checking `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{` and downloading dependencies.`}</p>
    <p>{`For `}<inlineCode parentName="p">{`list`}</inlineCode>{` this means the output will be based on the tree described by the
`}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{`, rather than the contents of `}<inlineCode parentName="p">{`node_modules`}</inlineCode>{`.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`omit`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: 'dev' if the `}<inlineCode parentName="li">{`NODE_ENV`}</inlineCode>{` environment variable is set to
'production', otherwise empty.`}</li>
      <li parentName="ul">{`Type: "dev", "optional", or "peer" (can be set multiple times)`}</li>
    </ul>
    <p>{`Dependency types to omit from the installation tree on disk.`}</p>
    <p>{`Note that these dependencies `}<em parentName="p">{`are`}</em>{` still resolved and added to the
`}<inlineCode parentName="p">{`package-lock.json`}</inlineCode>{` or `}<inlineCode parentName="p">{`npm-shrinkwrap.json`}</inlineCode>{` file. They are just not
physically installed on disk.`}</p>
    <p>{`If a package type appears in both the `}<inlineCode parentName="p">{`--include`}</inlineCode>{` and `}<inlineCode parentName="p">{`--omit`}</inlineCode>{` lists, then
it will be included.`}</p>
    <p>{`If the resulting omit list includes `}<inlineCode parentName="p">{`'dev'`}</inlineCode>{`, then the `}<inlineCode parentName="p">{`NODE_ENV`}</inlineCode>{` environment
variable will be set to `}<inlineCode parentName="p">{`'production'`}</inlineCode>{` for all lifecycle scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`foreground-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Run all build scripts (ie, `}<inlineCode parentName="p">{`preinstall`}</inlineCode>{`, `}<inlineCode parentName="p">{`install`}</inlineCode>{`, and `}<inlineCode parentName="p">{`postinstall`}</inlineCode>{`)
scripts for installed packages in the foreground process, sharing standard
input, output, and error with the main npm process.`}</p>
    <p>{`Note that this will generally make installs run slower, and be much noisier,
but can be useful for debugging.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`ignore-scripts`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`If true, npm does not run scripts specified in package.json files.`}</p>
    <p>{`Note that commands explicitly intended to run a particular script, such as
`}<inlineCode parentName="p">{`npm start`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm stop`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm restart`}</inlineCode>{`, `}<inlineCode parentName="p">{`npm test`}</inlineCode>{`, and `}<inlineCode parentName="p">{`npm run-script`}</inlineCode>{`
will still run their intended script if `}<inlineCode parentName="p">{`ignore-scripts`}</inlineCode>{` is set, but they
will `}<em parentName="p">{`not`}</em>{` run any pre- or post-scripts.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspace`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default:`}</li>
      <li parentName="ul">{`Type: String (can be set multiple times)`}</li>
    </ul>
    <p>{`Enable running a command in the context of the configured workspaces of the
current project while filtering by running only the workspaces defined by
this configuration option.`}</p>
    <p>{`Valid values for the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config are either:`}</p>
    <ul>
      <li parentName="ul">{`Workspace names`}</li>
      <li parentName="ul">{`Path to a workspace directory`}</li>
      <li parentName="ul">{`Path to a parent workspace directory (will result in selecting all
workspaces within that folder)`}</li>
    </ul>
    <p>{`When set for the `}<inlineCode parentName="p">{`npm init`}</inlineCode>{` command, this may be set to the folder of a
workspace which does not yet exist, to create the folder and set it up as a
brand new workspace within the project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`workspaces`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or Boolean`}</li>
    </ul>
    <p>{`Set to true to run the command in the context of `}<strong parentName="p">{`all`}</strong>{` configured
workspaces.`}</p>
    <p>{`Explicitly setting this to false will cause commands like `}<inlineCode parentName="p">{`install`}</inlineCode>{` to
ignore workspaces altogether. When not set explicitly:`}</p>
    <ul>
      <li parentName="ul">{`Commands that operate on the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` tree (install, update, etc.)
will link workspaces into the `}<inlineCode parentName="li">{`node_modules`}</inlineCode>{` folder. - Commands that do
other things (test, exec, publish, etc.) will operate on the root project,
`}<em parentName="li">{`unless`}</em>{` one or more workspaces are specified in the `}<inlineCode parentName="li">{`workspace`}</inlineCode>{` config.`}</li>
    </ul>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`include-workspace-root`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`Include the workspace root when workspaces are enabled for a command.`}</p>
    <p>{`When false, specifying individual workspaces via the `}<inlineCode parentName="p">{`workspace`}</inlineCode>{` config, or
all workspaces via the `}<inlineCode parentName="p">{`workspaces`}</inlineCode>{` flag, will cause npm to operate only on
the specified workspaces, and not on the root project.`}</p>
    <p>{`This value is not exported to the environment for child processes.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`install-links`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: false`}</li>
      <li parentName="ul">{`Type: Boolean`}</li>
    </ul>
    <p>{`When set file: protocol dependencies that exist outside of the project root
will be packed and installed as regular dependencies instead of creating a
symlink. This option has no effect on workspaces.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/commands/npm-install"
        }}>{`npm install`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/cli/v8/using-npm/config"
        }}>{`config`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      